// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"625":"5ea74596","988":"817a9a78"}[chunkId] + ".css";
};